interface IPaxSecurityTooltipProps {
  dataPoint: any;
  label: string;
}

const PaxSecurityTooltip: React.FC<IPaxSecurityTooltipProps> = ({
  dataPoint,
  label,
}) => {
  const isScreeningTime = label === "Screening Time";
  const unit = isScreeningTime ? "m" : "%";
  const formattedTime =
    isScreeningTime && dataPoint.isZero
      ? "<1m"
      : dataPoint.data !== undefined
        ? `${dataPoint.data}${unit}`
        : "—";

  return (
    <article style={tooltipStyles.container} data-testid="pax-security-tooltip">
      <header style={tooltipStyles.header}>
        <span
          style={tooltipStyles.colorDot(dataPoint.color)}
          aria-hidden="true"
        />
        <strong style={{ fontWeight: 600, fontSize: "13px" }}>
          {dataPoint.legend ?? "—"}
        </strong>
      </header>

      <section style={tooltipStyles.body}>
        <dl style={tooltipStyles.row}>
          <dt style={tooltipStyles.label}>
            {isScreeningTime ? "Time" : "Capacity"}
          </dt>
          <dd style={tooltipStyles.value}>{formattedTime}</dd>
        </dl>
        <dl style={tooltipStyles.row}>
          <dt style={tooltipStyles.label}>Pax</dt>
          <dd style={tooltipStyles.value}>
            {dataPoint.yAxisCalloutData ?? "—"}
          </dd>
        </dl>
      </section>
    </article>
  );
};

export default PaxSecurityTooltip;

const tooltipStyles = {
  container: {
    display: "flex",
    flexDirection: "column" as const,
    gap: "8px",
    padding: "8px 12px",
    width: "max-content",
    minWidth: "80px",
    borderRadius: "4px",
    backgroundColor: "#ffffff",
    boxShadow: "0 2px 8px rgba(0,0,0,0.16)",
  },
  header: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
    paddingBottom: "6px",
    borderBottom: "1px solid #e0e0e0",
  },
  colorDot: (color: string) => ({
    width: "10px",
    height: "10px",
    borderRadius: "50%",
    flexShrink: 0,
    backgroundColor: color,
    marginTop: "2px",
  }),
  body: {
    display: "flex",
    flexDirection: "column" as const,
    gap: "4px",
  },
  row: {
    display: "flex",
    alignItems: "center",
    margin: 0,
    gap: "8px",
  },
  label: {
    color: "#666666",
    fontSize: "12px",
    fontWeight: 500,
    minWidth: "60px",
  },
  value: {
    fontSize: "12px",
    fontWeight: 600,
    marginInlineStart: 0,
    margin: 0,
    textAlign: "left" as const,
  },
};
